/**
 * Module NEUTRE « social-links » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/social-links.ts
 */
import { cmsNew } from "@/lib/cms/cms-new-i18n";
export type SocialPlatform =
  | "instagram"
  | "facebook"
  | "twitter"
  | "youtube"
  | "linkedin"
  | "mail"
  | "globe";

const SOCIAL_PLATFORM_VALUES: SocialPlatform[] = [
  "instagram",
  "facebook",
  "twitter",
  "youtube",
  "linkedin",
  "mail",
  "globe",
];

export function getSocialPlatformOptions(): ReadonlyArray<{
  label: string;
  value: SocialPlatform;
}> {
  return [
    { label: cmsNew("cms.new.options.social.instagram", "Instagram"), value: "instagram" },
    { label: cmsNew("cms.new.options.social.facebook", "Facebook"), value: "facebook" },
    { label: cmsNew("cms.new.options.social.twitter", "X / Twitter"), value: "twitter" },
    { label: cmsNew("cms.new.options.social.youtube", "YouTube"), value: "youtube" },
    { label: cmsNew("cms.new.options.social.linkedin", "LinkedIn"), value: "linkedin" },
    { label: cmsNew("cms.new.options.social.mail", "E-mail"), value: "mail" },
    { label: cmsNew("cms.new.options.social.globe", "Site web"), value: "globe" },
  ];
}


export type SocialLinkItem = {
  platform: SocialPlatform;
  url: string;
  label: string;
};

export type SocialLinksAlign = "left" | "center" | "right";

export function normalizeSocialPlatform(value: unknown): SocialPlatform {
  const v = String(value ?? "");
  return (SOCIAL_PLATFORM_VALUES as readonly string[]).includes(v)
    ? (v as SocialPlatform)
    : "globe";
}

export function normalizeSocialLinksAlign(value: unknown): SocialLinksAlign {
  const v = String(value ?? "");
  if (v === "center" || v === "right") return v;
  return "left";
}

export function normalizeSocialLinkItems(value: unknown): SocialLinkItem[] {
  if (!Array.isArray(value)) return [];
  const out: SocialLinkItem[] = [];
  for (const raw of value) {
    const o = raw as Partial<SocialLinkItem>;
    const url = String(o.url ?? "").trim();
    if (!url) continue;
    out.push({
      platform: normalizeSocialPlatform(o.platform),
      url,
      label: String(o.label ?? "").trim(),
    });
  }
  return out;
}
